<template>
    <div>
        <DCard
            padding
        >
            <ResellerForm
                :errors="errors"
                :customer="customer"
                @submit="storeReseller"
            />
        </DCard>
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

import ResellerForm from '~@/Components/Customers/ResellerProducts/Form'

export default {
    name: 'CustomerResellerProductsCreate',
    components: {
        ResellerForm
    },
    layout: [App, CustomerBase],
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        }
    },
    methods: {
        storeReseller (form) {
            form.post(this.$route('customers.customers.reseller-products.store', {
                customer: this.customer.id
            }))
        }
    }
}
</script>
